module.exports = __webpack_public_path__ + "media/images/logo-ae2c9ff49cde513faf3d16cc5355991a.svg";